import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation21({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    setTimeout(() => setShowBadge(true), 100)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes spiralIn {
          0% {
            transform: rotate(720deg) scale(0) translateY(-200px);
            opacity: 0;
          }
          60% {
            transform: rotate(0deg) scale(1.2) translateY(0);
            opacity: 1;
          }
          80% {
            transform: rotate(-20deg) scale(0.9);
          }
          100% {
            transform: rotate(0deg) scale(1);
          }
        }
        @keyframes orbitParticle {
          0% {
            transform: rotate(var(--start-angle)) translateX(120px) rotate(calc(-1 * var(--start-angle)));
          }
          100% {
            transform: rotate(calc(var(--start-angle) + 360deg)) translateX(120px) rotate(calc(-1 * (var(--start-angle) + 360deg)));
          }
        }
        .spiral-in {
          animation: spiralIn 1.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }
        .orbit {
          animation: orbitParticle 3s linear infinite;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh] relative">
        {/* Particules en orbite */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          {[...Array(8)].map((_, i) => (
            <div
              key={i}
              className="orbit absolute w-4 h-4 bg-tessan-yellow rounded-full"
              style={{
                '--start-angle': `${i * 45}deg`,
                animationDelay: `${i * 0.1}s`,
                opacity: showBadge ? 1 : 0
              } as React.CSSProperties}
            />
          ))}
        </div>

        {/* Badge en spirale */}
        <div className={`relative z-10 ${showBadge ? 'spiral-in' : 'opacity-0'}`}>
          <div className="w-32 h-32 sm:w-44 sm:h-44 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50">
            <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-700 delay-1000 ${showBadge ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
